import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Drawer, Button, Badge, Avatar, Dropdown, Typography, Space, Divider } from "antd";
import Navbarmenu from "./navbarmenu";
import api from '../../services/axiosInstance';
import { BellOutlined, UserOutlined, CalendarOutlined, LogoutOutlined, KeyOutlined, MenuOutlined } from '@ant-design/icons';
import "../../styles/fluidDesign.css";
import { MAINVERSION } from "../appsettings";

import { getUser } from '../../services/authService';

const { Header } = Layout;
const { Text } = Typography;

const Headerdiv = () => {

  const navigate = useNavigate();
  const user = getUser();
  const UserID = localStorage.getItem("USERID");

  const [open, setOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [summary, setNotificationsummary] = useState([]);

  const onClose = () => {
    setOpen(false);
  };

  const logout = () => {
    localStorage.clear();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'My Profile',
      disabled: true,
    },
    {
      key: 'password',
      icon: <KeyOutlined />,
      label: 'Change Password',
      onClick: () => navigate('/updatepassword'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Sign Out',
      onClick: logout,
      danger: true,
    },
  ];

  React.useEffect(() => {

    if (UserID === "" || UserID === null) {
      navigate('/login');
    }


  }, [UserID, navigate]);

  return (
    <Header className="fluid-header">
      {/* Brand & Logo */}
      <div className="fluid-header-logo">
        {/* Universal Menu Button - Now first */}
        <Button
          type="text"
          className="fluid-header-icon-btn menu-trigger-btn"
          icon={<MenuOutlined style={{ fontSize: '20px', color: '#fff' }} />}
          onClick={() => setMobileMenuOpen(true)}
          style={{
            background: 'rgba(255,255,255,0.15)',
            border: 'none',
            borderRadius: '8px',
            width: '36px',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px'
          }}
        />

        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate('/dash')}>
          <img
            src="/mainlogo.png"
            alt="Logo"
            style={{
              width: '38px',
              height: '38px',
              borderRadius: '8px',
              objectFit: 'cover',
              border: '1.5px solid rgba(255,255,255,0.4)',
              marginRight: '12px'
            }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <div className="fluid-header-brand" style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ color: '#fff', fontWeight: 800, fontSize: '18px', letterSpacing: '1px' }}>ALMS <span style={{ fontSize: '12px', opacity: 0.7, fontWeight: 600 }}>{MAINVERSION}</span></span>
          </div>
        </div>
      </div>

      {/* Main Navigation (Hidden on top bar, moved to Drawer) */}
      <div className="fluid-header-nav" style={{ display: 'none' }}>
        <Navbarmenu />
      </div>

      <div style={{ flex: 1 }}></div> {/* Spacer to push actions to right */}

      {/* Right Actions */}
      <div className="fluid-header-actions">


        <Divider type="vertical" style={{ height: '24px', borderColor: 'rgba(255,255,255,0.1)' }} />

        {/* Enhanced User Profile Menu */}
        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottomRight"
          trigger={['click']}
          overlayStyle={{ paddingTop: '8px' }}
        >
          <div className="fluid-header-user">
            <Avatar
              size={34}
              icon={<UserOutlined style={{ color: '#fff' }} />}
              style={{
                backgroundColor: 'var(--fluid-primary-light)',
                border: '1.5px solid rgba(255,255,255,0.4)',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
              }}
            />
            <div className="fluid-header-user-info">
              <span className="fluid-header-user-name">{user?.displayName || 'User'}</span>
              <span className="fluid-header-user-role">{user?.role || user?.designation || 'System Access'}</span>
            </div>
          </div>
        </Dropdown>
      </div>

      {/* Notifications Drawer */}

      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '4px 0' }}>
            <img
              src="/mainlogo.png"
              alt="Logo"
              style={{ width: '32px', height: '32px', borderRadius: '6px' }}
            />
            <div style={{ color: 'var(--fluid-primary)', fontWeight: 800, fontSize: '18px', letterSpacing: '0.5px' }}>ALMS</div>
          </div>
        }
        onClose={() => setMobileMenuOpen(false)}
        open={mobileMenuOpen}
        placement="left"
        width={300}
        className="fluid-navigation-drawer"
        styles={{
          header: { borderBottom: '1px solid var(--fluid-border)', background: 'var(--fluid-bg-light)' },
          body: { padding: '12px' }
        }}
      >
        <Navbarmenu mode="inline" />
      </Drawer>

    </Header>
  );
};

export default Headerdiv;